
import { useLocation } from "react-router-dom";
import CreateNewPass from "../CreateNewPass";
import EmailVerification from "../EmailVerification";


const Firebase = (props) => {
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode")
    const oobCode = queryParams.get("oobCode")
    const apiKey = queryParams.get("apiKey")
    const lang = queryParams.get("lang")
    console.log(oobCode, mode)



    return (
        <>
            {mode == 'verifyEmail' ?
                <EmailVerification mode={mode} oobCode={oobCode} apiKey={apiKey} lang={lang} /> : <CreateNewPass />}
        </>
    );
}

export default Firebase;